import React from "react";

const ForecastIcon = ({
  width = 20,
  height = 20,
  fill = "#8884d8",
  ...props
}) => (
  <svg width={width} height={height} viewBox="0 0 24 24" fill="none" {...props}>
    <circle cx="12" cy="12" r="10" stroke={fill} strokeWidth="2" fill="none" />
    <path
      d="M7 13c1.5-2 4.5-2 6 0M9 16c.5-1 2.5-1 3 0"
      stroke={fill}
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
      fill="none"
    />
    <circle cx="12" cy="9" r="1.5" fill={fill} />
  </svg>
);

export default ForecastIcon;
